import React from 'react';
import { StyledTabs } from './index.style';
import TabItem from './TabItem';

const Tabs = ({
  tabs = [],
  activeTab,
  onChange,
  styleTabs,
  className,
  styleTab,
}) => (
  <StyledTabs styleTabs={styleTabs} className={className}>
    {tabs.map((tab) => (
      <TabItem
        key={tab.name}
        label={tab.label}
        count={tab.count}
        isActive={activeTab === tab.name}
        onClick={() => onChange(tab.name)}
        styleTab={styleTab}
      />
    ))}
  </StyledTabs>
);

export default Tabs;
